import routerOptions0 from "/vercel/path0/node_modules/.pnpm/nuxt@3.10.0_@parcel+watcher@2.4.0_@planetscale+database@1.16.0_@types+node@20.11.16_bufferuti_ja5hatueqoolppzeiim4bzlgs4/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export default {
...configRouterOptions,
...routerOptions0,
}